import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface StepFooterProps {
  onSkip: () => void;
  skipLabel?: string;
  primaryLabel?: string;
  /** Omit to make the primary button submit the surrounding form. */
  onPrimary?: () => void;
  busy?: boolean;
}

/** Every step can be skipped; the primary action saves (when there is anything to save) and moves on. */
export function StepFooter({
  onSkip,
  skipLabel = 'Skip for now',
  primaryLabel = 'Continue',
  onPrimary,
  busy = false,
}: StepFooterProps) {
  return (
    <div className="mt-8 flex items-center justify-between gap-3 border-t border-slate-100 dark:border-slate-800 pt-5">
      <Button type="button" variant="ghost" onClick={onSkip} disabled={busy}>
        {skipLabel}
      </Button>
      <Button type={onPrimary ? 'button' : 'submit'} onClick={onPrimary} disabled={busy}>
        {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        {primaryLabel}
      </Button>
    </div>
  );
}
